import { convertBlobToBase64 } from '../../../utils/convertBlobToBase64';
import { CADESCOM_BASE64_TO_BINARY, CADESCOM_PKCS7_TYPE, CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN } from '../constants';

export default function* sign(certData, documentBlob, detached = true) {
  try {
    const dataToSign = yield convertBlobToBase64(documentBlob, true);
    const oSigner = yield window.cadesplugin.CreateObjectAsync('CAdESCOM.CPSigner');
    const oSigningTimeAttr = yield window.cadesplugin.CreateObjectAsync('CADESCOM.CPAttribute');
    yield oSigningTimeAttr.propset_Name(window.cadesplugin.CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME);
    const oTimeNow = new Date();
    yield oSigningTimeAttr.propset_Value(oTimeNow);
    const attr = yield oSigner.AuthenticatedAttributes2;
    yield attr.Add(oSigningTimeAttr);
    // const oDocumentNameAttr = yield window.cadesplugin.CreateObjectAsync('CADESCOM.CPAttribute');
    // yield oDocumentNameAttr.propset_Name(window.cadesplugin.CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME);
    // yield oDocumentNameAttr.propset_Value('actFile.pdf');
    // yield attr.Add(oDocumentNameAttr);
    yield oSigner.propset_Certificate(certData.cert);
    yield oSigner.propset_CheckCertificate(true);
    const oSignedData = yield window.cadesplugin.CreateObjectAsync('CAdESCOM.CadesSignedData');
    yield oSignedData.propset_ContentEncoding(CADESCOM_BASE64_TO_BINARY);
    yield oSignedData.propset_Content(dataToSign);
    yield oSigner.propset_Options(CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN);
    const sSignedMessage = yield oSignedData.SignCades(oSigner, CADESCOM_PKCS7_TYPE, detached);
    return new Blob([sSignedMessage], { type: 'application/pgp-signature' });
  } catch (e) {
    return window.cadesplugin && window.cadesplugin.getLastError ? window.cadesplugin.getLastError(e) : 'Произошла ошибка подписания документа';
  }
}
